import type * as SchemaTypes from '../types';

import type { TranslatedStringDataFragment } from './TranslatedStringData';
import type { DealerContactFragmentFragment } from './DealerContactFragment';
import type { DealerSocialMediaFragmentFragment } from './DealerSocialMediaFragment';
import type { UploadFileWithPreviewFormDataFragment } from './UploadFileWithPreviewFormData';
import type { DealerDisclaimersFragmentFragment } from './DealerDisclaimersFragment';
import type { DealerIntegrationDetailsFragmentFragment } from './DealerIntegrationDetailsFragment';
import { gql } from '@apollo/client';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
import { DealerContactFragmentFragmentDoc } from './DealerContactFragment';
import { DealerSocialMediaFragmentFragmentDoc } from './DealerSocialMediaFragment';
import { UploadFileWithPreviewFormDataFragmentDoc } from './UploadFileWithPreviewFormData';
import { DealerDisclaimersFragmentFragmentDoc } from './DealerDisclaimersFragment';
import { DealerIntegrationDetailsFragmentFragmentDoc } from './DealerIntegrationDetailsFragment';
export type DealerApplicationFragmentFragment = (
  { __typename: 'Dealer' }
  & Pick<SchemaTypes.Dealer, 'id' | 'displayName' | 'isActive' | 'coe' | 'ppsr' | 'estFee'>
  & { legalName: (
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  ), contact: (
    { __typename: 'DealerContact' }
    & DealerContactFragmentFragment
  ), disclaimers: (
    { __typename: 'DealerDisclaimers' }
    & DealerDisclaimersFragmentFragment
  ), integrationDetails: (
    { __typename: 'DealerIntegrationDetails' }
    & DealerIntegrationDetailsFragmentFragment
  ), company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'coe' | 'ppsr' | 'estFee' | 'timeZone'>
  ) }
);

export const DealerApplicationFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DealerApplicationFragment on Dealer {
  id
  displayName
  legalName {
    ...TranslatedStringData
  }
  isActive
  coe
  ppsr
  estFee
  contact {
    ...DealerContactFragment
  }
  disclaimers {
    ...DealerDisclaimersFragment
  }
  integrationDetails {
    ...DealerIntegrationDetailsFragment
  }
  company {
    coe
    ppsr
    estFee
    timeZone
  }
}
    `;